var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('the-navigation-layout',{attrs:{"items":_vm.items,"title":_vm.$t('navigation.TheAboutList.header')}})
}
var staticRenderFns = []

export { render, staticRenderFns }